/** Regenerate rather than editing by hand: `WRITE_SHIP_UPGRADES=1 dotnet test tests/WarInSpace.Simulation.Tests` (pinned to `tests/vectors/ship-upgrades.json`). */
export const SHIP_NEXT_SHIPS: readonly (readonly number[])[] = [
  [1, 2, 3],
  [4, 5, 9],
  [5, 6, 7],
  [7, 8, 9],
  [10, 11, 21],
  [11, 12, 13],
  [13, 14, 15],
  [15, 16, 17],
  [17, 18, 19],
  [19, 20, 21],
];

export interface EvolutionChoice {
  readonly path: number;
  readonly shipId: number;
}

/** A row naming the same ship in all three paths collapses to one option — three identical portraits would read as a rendering fault. Path 1 (the centre column) survives the collapse. */
export function evolutionChoices(shipId: number): readonly EvolutionChoice[] {
  const row = SHIP_NEXT_SHIPS[shipId];
  if (row === undefined) return [];

  const identical = row.every((candidate) => candidate === row[0]);
  if (identical) {
    const only = row[1];
    return only === undefined ? [] : [{ path: 1, shipId: only }];
  }

  return row.map((candidate, path) => ({ path, shipId: candidate }));
}

export function canEvolve(shipId: number): boolean {
  return evolutionChoices(shipId).length > 0;
}
